import { create } from 'zustand';

interface PendingMessage {
  readonly text: string;
  /** Monotonic ID — lets the consumer detect a fresh push of identical text. */
  readonly id: number;
}

interface BlockTerminalPendingStore {
  readonly pending: PendingMessage | null;
  readonly setPending: (text: string) => void;
  readonly consumePending: () => PendingMessage | null;
}

let nextId = 1;

/**
 * One-shot inbox for messages that other UnifiedRfqs surfaces want the
 * Block Terminal to send on the user's behalf (e.g. a "Analyze in
 * Terminal" trade-tape context-menu action). The producer sets, the
 * Block Terminal drains it once the agent is authenticated.
 *
 * Keyed by a monotonic id so the consumer can tell a re-push of the
 * same text from the previous one.
 */
export const useBlockTerminalPendingStore = create<BlockTerminalPendingStore>(
  (set, get) => ({
    pending: null,
    setPending: (text) => {
      set({ pending: { text, id: nextId++ } });
    },
    consumePending: () => {
      const current = get().pending;
      if (current == null) return null;
      set({ pending: null });
      return current;
    },
  }),
);
